import React from "react";
import { Warning, Info, WarningOctagon } from "@phosphor-icons/react";
import { money } from "./fields";

const IUL_COLS = [["age", "Age"], ["premium", "Premium"], ["charges", "Charges"], ["credited", "Credited"], ["account_value", "Account value"],
  ["surrender_value", "Surrender value"], ["loan_draw", "Loan income"], ["loan_balance", "Loan balance"], ["net_cash_value", "Net cash value"], ["death_benefit", "Death benefit"]];
const FIA_COLS = [["age", "Age"], ["premium", "Premium"], ["credited", "Credited"], ["rider_fee", "Rider fee"], ["withdrawal", "Withdrawal"],
  ["accumulation_value", "Accum. value"], ["surrender_charge_pct", "Surr. %"], ["surrender_value", "Surrender value"], ["income_base", "Income base"], ["net_income", "After-tax income"]];
const QUAL_COLS = [["age", "Age"], ["start_balance", "Start balance"], ["withdrawal", "Withdrawal"], ["rmd", "RMD"], ["taxes", "Taxes"], ["net_income", "After-tax income"], ["end_balance", "End balance"]];

export const COLS = { iul: IUL_COLS, fia: FIA_COLS, keep: QUAL_COLS };

export const YearTable = ({ rows, kind, incomeStart, flagAge, testid }) => (
  <div data-testid={testid} className="border border-exodus-border overflow-auto max-h-[520px]">
    <table className="w-full text-xs min-w-[760px]">
      <thead className="sticky top-0 bg-exodus-elevated z-10">
        <tr>{COLS[kind].map(([k, l]) => <th key={k} className="p-2.5 text-right first:text-left text-[10px] uppercase tracking-wider text-exodus-muted font-normal">{l}</th>)}</tr>
      </thead>
      <tbody className="font-mono">
        {rows.map((r) => (
          <tr key={r.age} className={`border-t border-exodus-border/60 ${r.age === incomeStart ? "bg-exodus-gold/10" : ""} ${flagAge && r.age >= flagAge ? "text-red-300/80" : ""}`}>
            {COLS[kind].map(([k]) => (
              <td key={k} className="p-2.5 text-right first:text-left whitespace-nowrap">
                {k === "age" ? r.age : k === "surrender_charge_pct" ? `${Math.round(r[k])}%` : money(r[k])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ICON = { danger: WarningOctagon, warn: Warning, info: Info };
const TONE = { danger: "border-red-500/50 bg-red-500/10", warn: "border-exodus-gold/50 bg-exodus-gold/5", info: "border-exodus-border bg-exodus-surface" };

export const Warnings = ({ items, only }) => (
  <div data-testid="ro-warnings" className="space-y-2">
    {items.filter((w) => !only || only.includes(w.code)).map((w) => {
      const I = ICON[w.level];
      return (
        <div key={w.code} data-testid={`ro-warning-${w.code}`} className={`flex gap-3 border p-3 text-xs leading-relaxed ${TONE[w.level]}`}>
          <I size={16} className={w.level === "danger" ? "text-red-400 shrink-0" : "text-exodus-gold shrink-0"} />
          <span>{w.text}</span>
        </div>
      );
    })}
  </div>
);

export const DISCLOSURES = [
  "Not an offer of insurance. This is a hypothetical, educational model, not a carrier illustration.",
  "Values are not guaranteed. Caps, participation rates, spreads, charges and loan rates can change.",
  "Actual carrier illustrations may differ materially.",
  "Past index performance is not indicative of future results.",
  "Tax rules can change. This is a simplified estimate. Confirm with your tax professional and licensed advisor.",
  "Consult a licensed professional before moving retirement money.",
];

export const Disclosures = () => (
  <div data-testid="ro-disclosures" className="border-t border-exodus-border pt-6 mt-10">
    <p className="eyebrow text-exodus-muted mb-3">Important</p>
    <ul className="space-y-1.5 text-[11px] text-exodus-muted leading-relaxed list-disc pl-4">
      {DISCLOSURES.map((d) => <li key={d}>{d}</li>)}
    </ul>
  </div>
);
